import axios from "axios";
import React, { useEffect, useState } from 'react';
import { useParams, Routes, Route, useLocation } from "react-router-dom";

import { Header } from "../../components/Header";
import { ProgressBar} from "../../components/ProgressBar";
import { Activity} from "../../components/Activity";

import { useCheckAuth } from "../../hooks/useCheckAuth";
import { mergeWithActivitiesContent } from "./utils";
import { LEARN_ACTIVITIES } from "../../content/Topics/Land_Nature/learn_data";
import { API_URL } from "../../constants";

import { ActivityStatusWithContent, StateType } from "./Lesson.type";

import './Lesson.styles.scss';

export const Lesson: React.FC<any> = ({ user }) => {
  const { topicName, lessonType } = useParams();
  const location = useLocation();
  const { activities = [], type = '' } = (location?.state as StateType) || {};
  activities?.sort((a, b) => a.order - b.order);
  const activitiesIds = activities?.map(item => item.id)
  const [error, setError] = useState(null);

  const [activitiesWithStatusAndContent, setActivitiesWithStatusAndContent] = useState<ActivityStatusWithContent[]>();

  useCheckAuth();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(`${API_URL}/activities`, {
          withCredentials: true,
          ids: activitiesIds,
        });
        if(!!response?.data.length) {
          // console.log('response.data', response.data)
          const mergedActivities = mergeWithActivitiesContent({ activitiesProgress: activities, activitiesContent: response.data })
          // console.log('activitiesStatusWithContent', mergedActivities)
          setActivitiesWithStatusAndContent(mergedActivities);
        }
      } catch (err: any) {
        setError(err.response?.data?.message || err.message);
      }
    };

    fetchData();
  }, []);

  // console.log("activitiesWithStatusAndContent", activitiesWithStatusAndContent);
  return (
    <>
      <Header goBack={true} logOut={true} />
      <main className="LandingContainer Activity">
        <div className="Wrapper">
          <ProgressBar />
          <Routes>
            {/*{!!activitiesWithStatusAndContent?.length && activitiesWithStatusAndContent.map(activity => (*/}
            {/*  <Route path={`${activity.id}`} element={<Activity data={activity || {}}/>}/>*/}
            {/*  // <Route path="/topic/land-nature/learn" element={<Activity data={activity || {}}/>}/>*/}
            {/*))*/}
            {/*}*/}
            <Route path={`${LEARN_ACTIVITIES[0].id}`} element={<Activity type={type} />}/>
            {/*<Route path="/topic/land-nature/learn" element={<Activity data={activitiesWithStatusAndContent || []}/>}/>*/}
          </Routes>
        </div>
      </main>
    </>
  );
};
